import { render, staticRenderFns } from "./milestone_popover.vue.js?vue&type=template&id=e07a369c!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./milestone_popover.vue?vue&type=template&id=e07a369c"
import script from "./milestone_popover.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./milestone_popover.vue?vue&type=script&lang=js"
export * from "./milestone_popover.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./milestone_popover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e07a369c')) {
      api.createRecord('e07a369c', component.options)
    } else {
      api.reload('e07a369c', component.options)
    }
    module.hot.accept("./milestone_popover.vue.js?vue&type=template&id=e07a369c!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./milestone_popover.vue?vue&type=template&id=e07a369c", function () {
      api.rerender('e07a369c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "issuable/popover/components/milestone_popover.vue"
export default component.exports